import VeeValidate from "vee-validate";
import Vue from "vue";
Vue.use(VeeValidate);
